import { render, staticRenderFns } from "./portal-login.vue?vue&type=template&id=4d860b33"
import script from "./portal-login.vue?vue&type=script&lang=js"
export * from "./portal-login.vue?vue&type=script&lang=js"
import style0 from "./portal-login.vue?vue&type=style&index=0&id=4d860b33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports